<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>Endorsements</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
        <button v-scroll-to="'#bottom'" class="btn btn-primary" @click="handleAddNewEndorsementCallback" :disabled="haveUnsavedEndorsement"><i class="fa fa-plus"></i> Add New</button>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">

        <ul class="item-detail">
          <profile-talent-endorsements-list-item
            v-for="(endorsement, index) in endorsements"
            :key="endorsement.id"
            :index="index"
            :endorsement="endorsement"/>

          <li v-if="haveNoEndorsements" class="text-center">
            There are no endorsements.
          </li>
        </ul>
        <div id="bottom"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import ProfileTalentEndorsementsListItem from './ProfileTalentEndorsementsListItem'

export default {
  components: {
    ProfileTalentEndorsementsListItem
  },

  mounted () {
    this.getTalentEndorsements({
      talentId: this.$route.params.id
    })
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('talent/endorsement', ['endorsements']),
    ...mapGetters('talent/endorsement', ['haveNoEndorsements', 'haveUnsavedEndorsement'])
  },

  methods: {
    ...mapActions('talent/endorsement', ['getTalentEndorsements', 'addEndorsement']),

    /**
     * Handle adding a new endorsement.
     *
     * Pushes a new endorsement to the end of the state.
     *
     * @return void
     */
    handleAddNewEndorsementCallback () {
      if (!this.haveUnsavedEndorsement) {
        this.addEndorsement()
      }
    }
  }
}
</script>
